export const setScroll = (
    list: React.RefObject<HTMLDivElement>,
    currentPosition: number,
    direction: 'up' | 'down' | ''
) => {
    if (list.current) {
        const liElements = list.current.children.item(0)!.children;
        const viewHeight = list.current.clientHeight;
        const offsetHeight = list.current.scrollTop;

        if (direction === 'down') {
            const currentElement = liElements.item(currentPosition) as ScrollElement;
            if (currentElement.offsetTop + currentElement.clientHeight > offsetHeight + viewHeight) {
                list.current.scrollTop = currentElement.offsetTop + currentElement.clientHeight - viewHeight;
            } else if (currentElement.offsetTop + currentElement.clientHeight <= offsetHeight) {
                list.current.scrollTop = currentElement.offsetTop;
            }
        } else if (direction === 'up') {
            const currentElement = liElements.item(currentPosition) as ScrollElement;
            if (currentElement.offsetTop + currentElement.clientHeight <= offsetHeight) {
                list.current.scrollTop = currentElement.offsetTop;
            } else if (currentElement.offsetTop + currentElement.clientHeight > offsetHeight + viewHeight) {
                list.current.scrollTop = currentElement.offsetTop + currentElement.clientHeight - viewHeight;
            }
        }
    }
};

export const unmaskPhoneNumber = (
    phoneNumber: string,
) => {
    return phoneNumber.replace(/\D/g, '');
};

export const maskPhoneNumber = (
    phoneNumber: string,
) => {
    const digits = unmaskPhoneNumber(phoneNumber);
    if (digits.length !== 10) {
        return phoneNumber;
    }
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
};
